export default __webpack_public_path__ + "static/media/expl-nn_05_EN.4049fea6.png";